import React, { useState } from 'react';
import PanelWithClassification from '../PanelWithClassification';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter,
} from '../ui/Dialog';
import { Button } from '../ui/Button';

interface PickClassificationModalProps {
  visible?: boolean;
  onSubmit?: (item: any) => void;
  onClose?: () => void;
  url?: string;
  pickerUrl?: string;
}

const PickClassificationModal = ({
  visible,
  onSubmit,
  onClose,
  url,
}: PickClassificationModalProps = {}) => {
  const [activeItem, setActiveItem] = useState(null);
  const handleMakeActive = async (item) => {
    setActiveItem(item);
  };

  const reset = () => {
    setActiveItem(null);
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  const handleSubmit = () => {
    if (activeItem) {
      onSubmit(activeItem);
      reset();
    }
  };

  return (
    <Dialog open={visible} onOpenChange={handleClose}>
      <DialogContent className="w-[calc(100%-2rem)] sm:max-w-[800px]">
        <DialogHeader>
          <DialogTitle>Vyberte položku</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <div className="flex h-[450px] max-h-[60vh] min-h-0">
            <div className="border-x border-neutral-200 min-w-0 flex-1">
              <PanelWithClassification
                makeActive={handleMakeActive}
                valueAsObject
                active={activeItem?.id as any}
                onSearch={() => {}}
                addItem={() => {}}
                onFilter={() => {}}
                className="min-h-0"
                width="100%"
                url={url}
              />
            </div>
          </div>
        </DialogBody>
        <DialogFooter>
          <Button
            key={1}
            data-testid="pick-classification-modal-close-btn"
            variant="outline"
            onClick={handleClose}
          >
            Zavřít
          </Button>
          <Button
            key={2}
            data-testid="pick-classification-modal-confirm-btn"
            onClick={handleSubmit}
            disabled={!activeItem}
          >
            Potvrdit
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default PickClassificationModal;
